import { IconBin, IconDrive, IconQuery, IconStatement, IconServices } from '../assets/Icons';
import { ManualIcon, StcoPortalIcon, SupportIcon, SupportIconRed } from '../assets/images';
import {
  ChangeClientPasswordIcon,
  SideBarHome,
  SideBarServices,
  SideBarAssignClients,
  SideBarAllUsersAndClients,
  SideBarPayment,
  SideBarBuy,
  SideBarAbout,
} from '../components/Icon';


type MenuType = {
  title: string;
  to: string | null;
  icon?: any;
  key: string;
  activeIcon?: any;
  target?: string;
  fontIcon?: String;
  isNew?: boolean;
  comingSoon?: boolean;
}

type ExternalMenuType = {
  title: string;
  externalLink: string;
  icon: any;
}

export const ADMIN_MENU: MenuType[] = [
  {
    title: 'Home',
    to: '/',
    icon: <SideBarHome color="#484848" />,
    key: 'ROOT',
    activeIcon: <SideBarHome color="#DD4433" />,
  },

  {
    title: 'Services',
    to: '/services',
    icon: <SideBarServices color="#484848" />,
    key: "Services",
    activeIcon: <SideBarServices color="#DD4433" />
  },
  {
    title: 'Assign Columns',
    to: '/assign-columns',
    icon: <i className="las la-object-ungroup" style={{ fontSize: '25px' }}></i>,
    key: "AssignColumns",
    activeIcon: <i className="las la-object-ungroup" style={{ fontSize: '25px' }}></i>
  },
  {
    title: 'Invoice Columns',
    to: '/assign-invoice-columns',
    icon: <i className="las la-clipboard-check" style={{ fontSize: '25px' }}></i>,
    key: "AssignColumnsNew",
    activeIcon: <i className="las la-clipboard-check" style={{ fontSize: '20px' }}></i>,
    // isNew: true
  },
  {
    title: 'Assign Clients',
    to: '/assign-clients',
    icon: <SideBarAssignClients color="#484848" />,
    key: "AssignClients",
    activeIcon: <SideBarAssignClients color="#DD4433" />
  },
  {
    title: 'Open Items',
    to: '/open-items-admin',
    key: "Open Items",
    activeIcon: <i className="las la-box-open"></i>,
    icon: <i className="las la-box-open"></i>,
    // isNew: true
  },
  {
    title: 'Admin Reports',
    to: '/admin-reports',
    key: "Admin Reports",
    activeIcon: <i className="fas fa-chart-bar" style={{ fontSize: '25px' }}></i>,
    icon: <i className="fas fa-chart-bar" style={{ fontSize: '25px' }}></i>,
    // isNew: true
  },
  {
    title: 'Things To Do',
    to: '',
    key: "Things To Do",
    activeIcon: <i className="las la-list-alt"></i>,
    icon: <i className="las la-list-alt"></i>,
    comingSoon: true
  },
  {
    title: 'User Management',
    to: '/user-management',
    key: "UserManagement",
    activeIcon: <i className="las la-users" style={{ fontSize: '25px' }}></i>,
    icon: <i className="las la-users" style={{ fontSize: '25px' }}></i>,
    isNew: true
  },
  {

    title: 'All Users & Clients',
    to: '/user-clients-list',
    icon: <SideBarAllUsersAndClients color="#484848" />,
    key: "User",
    activeIcon: <SideBarAllUsersAndClients color="#DD4433" />
  },
  {
    title: 'Change Credentials',
    to: '/change-credentials',
    icon: <ChangeClientPasswordIcon color="#484848" />,
    key: "ChangeClientCredentials",
    activeIcon: <ChangeClientPasswordIcon color="#DD4433" />
  }
];

export const CLIENT_MENU: MenuType[] = [
  {
    title: 'Home',
    to: '/',
    icon: <SideBarHome color="#484848" />,
    key: 'ROOT',
    activeIcon: <SideBarHome color="#DD4433" />,
  },
  {
    title: 'Things To Do',
    to: '',
    key: "Things To Do",
    activeIcon: <i className="las la-list-alt"></i>,
    icon: <i className="las la-list-alt"></i>,
    comingSoon: true
  },
  {
    title: 'Services',
    to: '/services',
    icon: <SideBarServices color="#484848" />,
    key: "Services",
    activeIcon: <SideBarServices color="#DD4433" />
  }
];

export const USER_MENU: MenuType[] = [
  {
    title: 'Home',
    to: '/',
    icon: <SideBarHome color="#484848" />,
    key: 'ROOT',
    activeIcon: <SideBarHome color="#DD4433" />,
  },
  {
    title: 'Services',
    to: '/services',
    icon: <SideBarServices color="#484848" />,
    key: "Services",
    activeIcon: <SideBarServices color="#DD4433" />
  },
  {
    title: 'Open Items',
    to: '/open-items-admin',
    key: "Open Items",
    activeIcon: <i className="las la-box-open"></i>,
    icon: <i className="las la-box-open"></i>,
  },
  {
    title: 'All Open Jobs',
    to: '/all-open-jobs',
    key: "All Open Jobs",
    activeIcon: <i className="las la-business-time"></i>,
    icon: <i className="las la-business-time"></i>,
  },
  {
    title: 'Things To Do',
    to: '',
    key: "Things To Do",
    activeIcon: <i className="las la-list-alt"></i>,
    icon: <i className="las la-list-alt"></i>,
    comingSoon: true
  },
];

export const EXTRA_MENU: MenuType[] = [
  {
    title: 'Support',
    to: '/support',
    icon: SupportIcon,
    // fontIcon: "las la-headset",
    key: "Support",
    activeIcon: SupportIconRed
  },
];

export const EXTERNAL_MENU: ExternalMenuType[] = [
  {
    title: 'Buy Services',
    externalLink: 'https://filings.akssai.com/shop/',
    icon: <SideBarBuy color="#484848"/>
  },
  {
    title: 'About us',
    externalLink: 'https://akssai.com',
    icon: <SideBarAbout color="#484848"/>
  },
  {
    title: 'Payments',
    externalLink: 'https://pages.razorpay.com/stco',
    icon:<SideBarPayment color="#484848"/>
  },
  {
    title: 'Manual',
    externalLink: 'https://stco.sharepoint.com/sites/Manual',
    icon:<img src={ManualIcon} alt="manual-icon" width="24" height="24"/>
  },
  {
    title: 'STCO Portal',
    externalLink: 'https://stco.sharepoint.com/sites/stcoportal',
    icon:<img src={StcoPortalIcon} alt="manual-icon" width="24" height="24"/>
  }
];